<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ALbV8e/tc-custom/9781845137274.jpg?1731055747816" alt="This image is the cover for the book The Barbed-Wire University"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Barbed-Wire University
      </h1>
      <p class="bookDescription body article font2">
        <b>“A moving and eye-opening account of the lives of second world war PoWs by the daughter of a man who was captured . . . a riveting collection of stories.” —<i>The Guardian</i></b><br/><br/>Feature films like <i>The Bridge on the River Kwai</i> and <i>The Great Escape</i> have created the stereotype of the Second World War prisoner of war. But, as Midge Gillies shows in this groundbreaking work of social history, the true experiences of nearly half a million Allied servicemen held captive during the Second World War were nothing like the Hollywood myth—and infinitely more extraordinary.<br/><br/>The real lives of POWs saw them respond to the tedium of a German stalag or the brutality of a Japanese camp with the most amazing ingenuity and creativity. They staged glittering shows, concerts and elaborate sporting fixtures, made exquisite ornaments—even, amid the terrible privations of the Thailand-Burma railway, improvised daring surgical techniques to save their fellow men’s lives. Whatever skills or hobbies they took with them to captivity they managed to continue and adapt—to the extent of laying out a 9-hole golf course between the huts of one German camp. They took up crafts and pastimes using materials they found around them: even the string from a Red Cross food parcel was used to make cricket balls, football nets and wigs for theatrical performances. Men studied, attended lectures, learned languages, sat for qualifications and exams, on such a scale that one camp was nicknamed “The Barbed-Wire University.”<br/><br/>Drawing on letters home, diaries and interviews with redoubtable survivors now into their nineties, Midge Gillies recreates the daily lives of a truly remarkable group of men. <br/><br/><b>“Astonishing tales of improvisation, ingenuity and courage.” —<i>The Spectator</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Midge Gillies
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aurum Press Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d29d2adc